/* src/pages/Agency.jsx
 * Retired marketing page. The agency story now lives on the marketing site
 * at gocta.ai/agencies (site/src/pages/agencies.astro) - this route just
 * redirects there so old links (app.gocta.ai/agency,
 * smartforms-ai.web.app/agency) keep working.
 */

import React, { useEffect } from 'react';

const AGENCIES_URL = 'https://gocta.ai/agencies';

export default function Agency() {
  useEffect(() => {
    window.location.replace(AGENCIES_URL);
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 24, textAlign: 'center' }}>
      <p style={{ color: '#333', fontSize: 16 }}>
        Redirecting to <a href={AGENCIES_URL}>{AGENCIES_URL}</a>...
      </p>
    </div>
  );
}
